@if (data) {
  <section class="popular-courses py-v-spacing" [ngClass]="[theme?.root, theme?.container]">
    <div class="container mx-auto px-4">
      @if (dynamicSectionTitle) {
        <h2 class="popular-courses__title">{{ dynamicSectionTitle }}</h2>
      }
      <div class="popular-courses__grid grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div class="popular-courses__slot">
          @if (courseOneItem && courseOneItem.ctaLink) {
            @if (courseOneCardBorderClass) {
              <product-pill class="ace-mode-pill-overlay" [pills]="courseOne?.productPills"></product-pill>
            }
            <a
              [href]="courseOneItem.ctaLink"
              class="popular-courses__card h-full cursor-pointer p-6 justify-between items-center gap-4 inline-flex w-full shadow-card rounded-ace-mode bg-white no-underline"
              [class]="courseOneCardBorderClass"
            >
              <div class="flex-grow">
                <div class="card-title wysiwyg" [innerHTML]="courseOneItem.cardTitle"></div>
              </div>
              <div class="!w-12 h-12 !p-0 shrink-0 primary-button transition">
                <fa-icon [icon]="faArrowRight"></fa-icon>
              </div>
            </a>
          }
        </div>
        <div class="popular-courses__slot">
          @if (courseTwoItem && courseTwoItem.ctaLink) {
            @if (courseTwoCardBorderClass) {
              <product-pill class="ace-mode-pill-overlay" [pills]="courseTwo?.productPills"></product-pill>
            }
            <a
              [href]="courseTwoItem.ctaLink"
              class="popular-courses__card h-full cursor-pointer p-6 justify-between items-center gap-4 inline-flex w-full shadow-card rounded-ace-mode bg-white no-underline"
              [class]="courseTwoCardBorderClass"
            >
              <div class="flex-grow">
                <div class="card-title wysiwyg" [innerHTML]="courseTwoItem.cardTitle"></div>
              </div>
              <div class="!w-12 h-12 !p-0 shrink-0 primary-button transition">
                <fa-icon [icon]="faArrowRight"></fa-icon>
              </div>
            </a>
          }
        </div>
      </div>
      @if (viewAllCoursesLink) {
        <div class="flex mt-8 md:mt-12 justify-center">
          <a [attr.href]="viewAllCoursesLink" class="tertiary-button !font-normal">
            {{ viewAllCoursesLabel }}
          </a>
        </div>
      }
    </div>
  </section>
}
